<template>
    <TaxesComp />
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const TaxesComp = defineAsyncComponent(() => import('@/components/managementPages/taxesPage/taxesComp.vue'))

</script>